import { Box, Typography, useTheme } from '@mui/material';
import { important } from '../../utils/global/helper';

interface Props {
  name: string;
  showing: number;
  total: number;
  small?: boolean;
}

export default function TableTitle({ name, showing, total, small }: Props) {
  const theme = useTheme();
  return (
    <Box
      className="table-title-row"
      sx={{
        paddingY: small ? important(theme.spacing(2.5)) : undefined,
      }}>
      <Typography
        variant="h2"
        fontSize={small ? theme.typography.body2.fontSize : undefined}>
        {name}
      </Typography>
      <Typography
        variant="body1"
        fontSize={small ? theme.typography.body2.fontSize : undefined}>
        Showing {showing} of {total}
      </Typography>
    </Box>
  );
}
